import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-trainingcenter-program',
  templateUrl: './trainingcenter-program.page.html',
  styleUrls: ['./trainingcenter-program.page.scss'],
})
export class TrainingcenterProgramPage implements OnInit {
  selectprogram : any;
  selectprogram1 : any;
  prodismiss : any;

  constructor(
    public modalCtrl:ModalController,
    public addCall: AddCall,)
   { }

  ngOnInit() {
  }
   
  

  dismiss() {
    this.modalCtrl.dismiss({
      selected_program:null,
      indexval:null,
    });
   
  }

  selectpro(Value,i){
    this.prodismiss = this.selectprogram[i]
    this.modalCtrl.dismiss({
      selected_program:this.selectprogram[i],
      indexval:i,
    });
  }

}
